import * as countries from "@/constants/countries"
const PhoneNumber = require('awesome-phonenumber');

export default {
  name: "login-modal",
  props: ["auth", "redirect"],
  components: {},
  data() {
    return {
      form: {
        phone: "",
        hash: "",
        remember: true
      },
      selectedCountry: null,
      fullPhone: "",
      selectedCountryCode: countries.data.find(country => country.name.toLowerCase() === "nigeria").dial_code,
      countries: countries.data,
      showPassword: false,
      phoneValid: false
    };
  },
  computed: {
    formValid: function() {
      return (!Object.entries(this.form).map(s => s[1]).find(s => s === "") &&
        this.form.hash.length >= 8 && this.phoneValid);
    },
  },
  methods: {
    submit: function(e) {
      if (!this.formValid) {
        return
      }
      const btn = e.submitter;
      const form = {
        phone: this.fullPhone,
        hash: this.form.hash,
        remember: this.form.remember
      };
      
      btn.innerText = "Logging in";
      btn.disabled = true;
      btn.classList.add("btn--loading");

      this.$props.auth
        .loginDefault(form)
        .then(response => {
          $("#loginModal").modal("hide");
          if(this.$props.redirect) {
            this.$props.auth.setSession(response, "default", this.$props.redirect);
          } else {
            this.$props.auth.setSession(response, "default");
          }
        })
        .catch(response => {
          this.$root.$emit("ShowErrorNotification", response.message);

          btn.innerText = "Log In";
          btn.classList.remove("btn--loading");
          btn.disabled = false;
        });
    },
    show: function() {
      try {
        this.showPassword = !this.showPassword;
      } catch (e) {}
    },
    toggleRemember: function() {
      this.form.remember = !this.form.remember;
    }
  },
  watch: {
    "selectedCountryCode": {
      handler: function(val) {
        this.selectedCountry = this.countries.find(country => country.dial_code === val);
        const phone = new PhoneNumber(this.form.phone, this.selectedCountry.code).a;
        if (phone.possibility !== "unknown") {
          this.fullPhone = phone.number["e164"];
          this.phoneValid = phone.valid;
        }
      },
      immediate: true,
      deep: true
    },
    "form.phone": {
      handler: function(val) {
        const phone = new PhoneNumber(val, this.selectedCountry.code).a;
        if (phone.possibility !== "unknown") {
          this.fullPhone = phone.number["e164"];
          this.phoneValid = phone.valid;
        }
      }
    }
  }
};
